import axios from "axios";
import { showToast } from "vant";
import { getUrlConfig, storage, logoutApp } from "@/utils";
// const token =
//   storage.get("token") ||
//   "IG9G7oFyXvFOiuq2Gqjf0nBkU3qeKD9d_oMg8M6YAYIaDeiIzNXLMncx-VVBHxdfPSkJPHIpB8k7WRfd9Q0d2kxWA6le_uoaMOGCzWbEoU8/";

// axios初始化
const instance = axios.create({
  // baseURL: "https://beta-zhujiao.knowbox.cn:9901/",
  baseURL: getUrlConfig().zhujiaoDomain,
  timeout: 60000, // 请求超时时间，设置60秒超时
  changeOrigin: true,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    // 'versionCode': '2',
    // 'appid': 'h5',
    // 'platform': 'h5'
  },
});

// axios请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = storage.get("token");
    // if (token) {
    //   config.headers["sessionId"] = token;
    // }
    let noNeedTokenRouter = [
      "/wechat/teacher/login-by-code",
      "/wechat/teacher/send-sms-code",
      "/wechat/teacher/sms-code-bind",
      "/wechat/teacher/send-sms-code-verify",
      "/wechat/teacher/sms-code-login-verify",
      "/wechat/teacher/sms-code-bind-verify",
      "/wechat/teacher/info",
      "/wechat/teacher/info-complete",
      "/wechat/teacher/personal-setting",
      "/html5/xueqing/city-version",
      "/teacher/app/get-pc-city-school",
      "/teacher/user-new/get-qiniu-token",
      "/teacher/user-new/user-jubao",
      "/wechat/teacher/sms-code-login",
      "/wechat/teacher/logout",
      "/html5/meeting/user-poster-detail",
      "/html5/meeting/get-province-list",
      "/html5/meeting/get-city-list",
      "/html5/meeting/get-country-list",
      "/html5/meeting/get-school-list",
      "/html5/meeting/sign-up-meeting",
      "/html5/meeting/get-open-link",
      "/html5/act/check-task-type",
      "/html5/act/finish-watch-course",
      "/html5/mini-act/check-activity",
    ];
    const stuapiApis = ["/html5/common/get-privacy-info", "/verify/get"];
    // console.log(111, config.url);
    if (config.url) {
      if (noNeedTokenRouter.includes(config.url)) {
        config.baseURL = getUrlConfig().loginDomain;
      } else if (stuapiApis.includes(config.url)) {
        config.baseURL = getUrlConfig().stuapiDomain;
      }
    }
    if (token) {
      let sourceDevice = storage.get("sourceDevice") || "h5Teacher";
      let version = storage.get("version") || "";

      {
        // 兼容修复？携带多个key变成数组的情况
        if (Array.isArray(sourceDevice) && sourceDevice.length > 0) {
          sourceDevice = sourceDevice[0];
          storage.set("sourceDevice", sourceDevice);
        }
        if (Array.isArray(version) && version.length > 0) {
          version = version[0];
          storage.set("version", version);
        }
      }

      if (config.method === "post") {
        if (!config.data) {
          config.data = {};
        }
        config.data["token"] = token;
        config.data["source"] = sourceDevice;
        if (version) {
          config.data["version"] = version;
        }
      } else {
        if (!config.params) {
          config.params = {};
        }
        config.params["token"] = token;
        config.params["source"] = sourceDevice;
        if (version) {
          config.params["version"] = version;
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 处理code异常
const handleCode = (code, msg) => {
  switch (code) {
    case 401: {
      // showToast(msg || "登录失效，请退出重新登录");
      // window.localStorage.clear()
      // window.location.href = `${import.meta.env.VITE_APP_BASE_URL}?next=${encodeURIComponent(
      //   window.location.href
      // )}`;
      break;
    }
    case 403: {
      break;
    }
    // 登录token失效
    case 20003: {
      // 小程序内失效返回到引导页面
      if (window.__wxjs_environment === "miniprogram") {
        const scene = storage.get("scene") || "";
        wx.miniProgram.reLaunch({
          url: `/pages/index/index?action=logout&scene=${scene}`,
        });
        return false;
      }
      const isApp = storage.get("sourceDevice");
      if (isApp) {
        logoutApp();
        return false;
      }
      storage.clear();
      window.location.replace(`${import.meta.env.VITE_APP_BASE_URL}`);
      break;
    }
    case 88888: {
      break;
    }
    default: {
      // showToast(msg || `后端接口${code}异常`);
      break;
    }
  }
};

// axios响应拦截器
instance.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 操作正常Code数组，code=0,99999 => ok
    const successCode = [0, 99999];
    // 是否操作正常
    if (successCode.includes(res?.code)) {
      return res;
    } else {
      const { code, msg } = res;
      handleCode(code, msg);
      return Promise.reject(res);
    }
  },
  (error) => {
    if (error.message.includes("canceled")) {
      // 请求中止
      return Promise.reject("canceled");
    } else if (error.message.includes("timeout")) {
      // 请求超时
      showToast(`请求超时, 请检查网络`);
      return Promise.reject("timeout");
    } else if (error?.response) {
      const { status, data } = error.response;
      handleCode(status, data?.msg || error.message);
      return Promise.reject(error);
    } else {
      let { message } = error;
      if (message === "Network Error") {
        message = "后端接口连接异常";
      }
      if (message.includes("timeout")) {
        message = "后端接口请求超时";
      }
      if (message.includes("Request failed with status code")) {
        const code = message.substr(message.length - 3);
        message = "后端接口" + code + "异常";
      }
      showToast(message || `后端接口未知异常`);
      return Promise.reject(error);
    }
  },
);

export default instance;
